import {styled} from '@linaria/react';
import React from 'react';
import {SkeletonBlock} from '../../../../atoms/Skeletons/SkeletonBlock';
import {BasketItemSkeleton} from './BasketItemSkeleton';

/**
 * @deprecated This component is deprecated because it violates best practices defined in the @aboutyou/ui-components.
 * Do not take inspiration from this component for new implementations.
 */
export const DeliveriesSkeleton = () => {
  return (
    <Wrapper>
      <SkeletonBlock $width="30%" $height="1.15rem" disableSpaceBelow />
      <BasketItemSkeleton />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 40px;
  padding: 1rem 1rem 0;
  border-bottom: 8px;
`;
